import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-application2",
  "use": "icon-application2-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-application2\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 18H10C10.2638 17.9989 10.5165 17.8936 10.703 17.707L17.703 10.707C17.7868 10.6222 17.8546 10.5229 17.903 10.414C17.9129 10.3926 17.9213 10.3706 17.928 10.348L17.937 10.321C17.9652 10.2373 17.9823 10.1502 17.988 10.062C17.9891 10.0525 17.9911 10.0431 17.994 10.034C17.9975 10.023 17.9996 10.0116 18 10V2C18 0.89543 17.1046 0 16 0H2C0.89543 0 0 0.89543 0 2V16C0 17.1046 0.89543 18 2 18ZM2 16V2H16V9H10C9.44772 9 9 9.44772 9 10V16H2ZM11 14.587V11H14.586L11 14.587ZM14 4H4V6H14V4Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/application2.svg
// module id = IMOi
// module chunks = 262